export enum AlertTrendEnum {
	Down = 'down-trend',
	Up = 'up-trend',
	NoChange = 'no-change',
	JustInfo = 'just-info',
}
